module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "aside"
  }, [_c('div', {
    staticClass: "aside-inner"
  }, [_c('nav', {
    staticClass: "sidebar",
    attrs: {
      "data-sidebar-anyclick-close": ""
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "has-user-block"
  }, [_c('div', {
    staticClass: "collapse in",
    attrs: {
      "id": "user-block"
    }
  }, [_c('div', {
    staticClass: "item user-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user-block-info"
  }, [_c('span', {
    staticClass: "user-block-name"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))]), _vm._v(" "), _c('span', {
    staticClass: "user-block-role"
  }, [_vm._v("IR Admin")])])])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'Users'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Users'
      },
      "title": "all users",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "icon-people"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.ACCOUNT"
    }
  }, [_vm._v("All Users")])])], 1), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'FailedTransactionList'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'FailedTransactionList'
      },
      "title": "trasactions",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "icon-dislike"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Cancelled/Failed Transactions")])])], 1), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadImpactPreferencesReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Impact Preferences Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadMonthlyMaturitiesReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Monthly Maturities Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadDocumentViewsReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Document Views Report")])])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.downloadFeedbackReport
    }
  }, [_c('em', {
    staticClass: "fa fa-download"
  }), _vm._v(" "), _c('span', [_vm._v("Export Feedback Report")])])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.$route.name === 'AdminSettings'
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'AdminSettings'
      },
      "title": "settings",
      "replace": ""
    }
  }, [_c('em', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "data-localize": "sidebar.nav.WIDGETS"
    }
  }, [_vm._v("Settings")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-block-picture"
  }, [_c('div', {
    staticClass: "user-block-status"
  }, [_c('img', {
    staticClass: "img-thumbnail img-circle",
    attrs: {
      "src": require("../assets/img/user/img-profile-default-admin.svg"),
      "alt": "Avatar",
      "width": "60",
      "height": "60"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06de54f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IRAdminSideBar.vue
// module id = 2099
// module chunks = 1